import React from 'react';

const Unauthorized = () => {
    return <div>Unauthorized Screen</div>;
};

export default Unauthorized;
